<ng-container *ngIf="accommodation?.code">
  <div class="accommodation-details">
    <div *ngIf="accommodation?.withPromotion" class="accommodation-details__promo" data-qa="accommodation_details_promo">
      <lx-label i18n-text text="Limited-time Deal"></lx-label>
    </div>

    <h3 class="accommodation-details__title" data-qa="accommodation_details_title">{{ accommodation.title }}</h3>

    <lx-accommodation-options [accommodation]="accommodation" [extended]="true"></lx-accommodation-options>

    <div class="accommodation-details__description" data-qa="accommodation_details_description">
      {{ accommodation.description }}
    </div>
  </div>
</ng-container>
